import React from 'react'
import { Popup } from '../../../../../components/Popup'
import { Box, Text } from '../../../../../designSystem'
import '../chapterAddEdit.css'

function WarningPopup({
  warningPopup,
  setWarningPopup,
  removeUnsavedChangesHandler,
  history,
}) {
  return (
    <Popup
      show={warningPopup}
      close={() => setWarningPopup(false)}
      renderActions={
        <>
          <button
            className="action-button"
            type="button"
            onClick={() => setWarningPopup(false)}
          >
            Cancel
          </button>
          <button
            className="action-button primary"
            type="button"
            onClick={() => {
              setWarningPopup(false)
              removeUnsavedChangesHandler()
              history.goBack()
            }}
          >
            Exit
          </button>
        </>
      }
    >
      <Box
        variant="flex"
        alignItems="center"
        mb={8}
        justifyContent="flex-start"
      >
        <Text variant="titleSecondary">Exit Warning!</Text>
      </Box>
      <Text variant="caption" lineHeight={1.8} fontWeight={500}>
        Are you sure you want to exit without saving ?
      </Text>
    </Popup>
  )
}

export default WarningPopup
